import React from 'react';

import './index.scss';

interface IEditTextProps {
    text: string
    handleAlignText: (alignment: string) => void
    handleTextChange: (text: string) => void
}

export const EditText = (props: IEditTextProps) => {

    const { text, handleAlignText, handleTextChange } = props

    return (
        <div className="editTextContainerDiv">
            <div className="editTextInptContainer">
                <form>
                    <textarea
                        className="editTextArea"
                        typeof="text"
                        value={text}
                        placeholder="TEXT"
                        onChange={({ target }) => {
                            handleTextChange(target.value)
                        }}
                    ></textarea>
                </form>
                <div className="editTextAlignmentContainer">
                    <div className="editTextAlignmentLabel">Text Alignment</div>
                    <div className="editTextAlignDiv">
                        <button onClick={() => {
                            handleAlignText("left")
                        }} className="editTextAlignLeftBtn" />
                    </div>
                    <div onClick={() => {
                        handleAlignText("center")
                    }} className="editTextAlignDiv">
                        <button className="editTextAlignCenterBtn" />
                    </div>
                    <div onClick={() => {
                        handleAlignText("right")
                    }} className="editTextAlignDiv">
                        <button className="editTextAlignRightBtn" />
                    </div>
                </div>
            </div>

        </div>
    )
}